export var checkNullOrUndefined = function (value, fallback) {
    return value !== null && value !== undefined && value !== '' ? value : fallback;
};
